import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Rating } from '@mui/material';
import { Restaurant } from '../../types';
import { S3_RESTAURANT_PLACEHOLDER } from '../../config';

interface RestaurantCarouselCardProps {
  restaurant: Restaurant;
  onClick: (restaurant: Restaurant) => void;
}

const RestaurantCarouselCard: React.FC<RestaurantCarouselCardProps> = ({ restaurant, onClick }) => {
  const imageUrl = restaurant.image_url || (restaurant.images && restaurant.images[0]?.url) || S3_RESTAURANT_PLACEHOLDER;

  return (
    <Card 
      sx={{ 
        minWidth: 280,
        maxWidth: 280,
        cursor: 'pointer',
        '&:hover': {
          transform: 'scale(1.02)',
          transition: 'transform 0.2s ease-in-out',
        },
      }}
      onClick={() => onClick(restaurant)}
    >
      <CardMedia
        component="img"
        height="140"
        image={imageUrl}
        alt={restaurant.name}
      />
      <CardContent>
        <Typography variant="h6" component="div" noWrap>
          {restaurant.name}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Rating value={restaurant.rating || 0} readOnly size="small" />
          <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
            {restaurant.rating?.toFixed(1) || 'No ratings'}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" noWrap>
          {restaurant.cuisines?.map((c: { id: number; name: string }) => c.name).join(', ')}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default RestaurantCarouselCard; 